import CaseBlockTitle from "../../common/case-block-title/case-block-title";
import iBluePolygon from "../../../assets/icons/blue-polygon.svg";
import iHeartMessage from "../../../assets/icons/heart-message.svg";
import iHeart from "../../../assets/icons/hero-text-block/hero-text-bg-left-center.png";
import iStar from "../../../assets/icons/hero-text-block/hero-text-bg-right.png";
import "./cases-list-block.sass";

type Props = {
  ulItems: {
    text: string;
    id: string | number;
  }[];
  title: string;
  subheading?: string;
};

const CasesListBlock = ({ title, subheading, ulItems }: Props) => {
  return (
    <div className="cases-list-block">
      {subheading && <CaseBlockTitle color="pink">{subheading}</CaseBlockTitle>}

      <div className="cases-list-block__title">{title}</div>

      <div className="cases-list-block__content">
        <div className="cases-list-block__list">
          {ulItems.map((item) => (
            <div key={item.id} className="cases-list-block__item">
              <img
                src={iBluePolygon}
                className="cases-list-block__polygon"
                alt=""
              />

              <div className="cases-list-block__text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>

      <img
        src={iHeartMessage}
        className="img-absolute cases-list-block__heart-message"
        alt=""
      />
      <img
        src={iHeart}
        className="img-absolute cases-list-block__heart"
        alt=""
      />
      <img src={iStar} className="img-absolute cases-list-block__star" alt="" />
    </div>
  );
};

export default CasesListBlock;
